import { AppShell } from "@/components/AppShell";

const Section = ({ title, children }) => (
  <div className="mb-6">
    <h2 className="text-lg font-serif text-[#D4AF37] mb-2">{title}</h2>
    <div className="text-sm text-[#C8C8C8] leading-relaxed space-y-2">{children}</div>
  </div>
);

export default function Terms() {
  return (
    <AppShell>
      <div className="max-w-2xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-serif text-white mb-2">Terms of Service</h1>
        <p className="text-xs text-[#5a5a66] mb-8">Last updated: {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}</p>

        <Section title="1. What THE CIRCLE is">
          <p>
            THE CIRCLE is a platform that helps people in Kolkata discover and join
            small, curated dinners hosted by other members ("Planners"). We facilitate
            introductions and handle deposit payments — we do not host, organize, or
            attend the dinners ourselves.
          </p>
        </Section>

        <Section title="2. Your responsibility at meetups">
          <p>
            You attend any dinner or meetup arranged through THE CIRCLE entirely at your
            own risk. THE CIRCLE is not responsible for the conduct of any member,
            for what happens during an in-person meetup, or for any loss, injury, or
            dispute arising from it. We encourage meeting in public places and
            exercising the same judgment you would with any new acquaintance.
          </p>
        </Section>

        <Section title="3. Eligibility">
          <p>You must be 18 years or older to use THE CIRCLE.</p>
        </Section>

        <Section title="4. Payments and deposits">
          <p>
            Deposits are collected securely via Razorpay. Deposit percentages, refund
            conditions, and THE CIRCLE's commission are shown at the time of payment.
            Refunds are processed by our admin team following a completed meetup.
          </p>
        </Section>

        <Section title="5. Prohibited conduct">
          <p>
            Harassment, threats, fraud, impersonation, or any illegal activity is
            strictly prohibited. Violating this may result in immediate account
            suspension and, where required by law, cooperation with authorities.
          </p>
        </Section>

        <Section title="6. Reporting">
          <p>
            If something goes wrong, report it through the Report feature in the app or
            by contacting our grievance officer below. We review all reports.
          </p>
        </Section>

        <Section title="7. Limitation of liability">
          <p>
            To the maximum extent permitted by law, THE CIRCLE and its operators are not
            liable for indirect, incidental, or consequential damages arising from your
            use of the platform or attendance at any meetup.
          </p>
        </Section>

        <Section title="8. Grievance Officer">
          <p>
            In accordance with the Information Technology Act, 2000 and rules made
            thereunder, the contact details of the Grievance Officer are:
          </p>
          <p className="text-white">
            Name: Himanshu Agarwal<br />
            Email: himanagarwal.cool@gmail.com<br />
            Response time: within 15 days of receipt of a complaint
          </p>
        </Section>

        <Section title="9. Governing law">
          <p>
            These terms are governed by the laws of India. Any disputes are subject to
            the exclusive jurisdiction of the courts in Kolkata, West Bengal.
          </p>
        </Section>

        <Section title="10. Changes to these terms">
          <p>We may update these terms from time to time. Continued use of THE CIRCLE after changes means you accept the updated terms.</p>
        </Section>

        <p className="text-xs text-[#5a5a66] mt-10 border-t border-white/10 pt-4">
          This is a general template and has not been reviewed by a lawyer. Consult a
          qualified lawyer before relying on it for a live, real-money platform.
        </p>
      </div>
    </AppShell>
  );
}
